import { HttpContextToken } from '@angular/common/http';

export const CAMEL_CASE_RESPONSE = new HttpContextToken<boolean>(() => true);

export const USE_AUTHENTICATION = new HttpContextToken<boolean>(() => true);
